import { render, staticRenderFns } from "./block-accident-details.vue?vue&type=template&id=8ab6fcaa&scoped=true&"
import script from "./block-accident-details.vue?vue&type=script&lang=js&"
export * from "./block-accident-details.vue?vue&type=script&lang=js&"
import style0 from "./block-accident-details.vue?vue&type=style&index=0&id=8ab6fcaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab6fcaa",
  null
  
)

export default component.exports